const getEnvironment = () => {
	const { origin } = window.location;
	if (origin.includes('localhost') || origin.includes('dev')) {
		return 'dev';
	}
	if (origin.includes('stg')) {
		return 'stg';
	}
	if (origin.includes('tst')) {
		return 'tst';
	}
	return 'prod';
};

export default getEnvironment;
